<div class="banners-container">
  <div class="d-flex justify-content-between align-items-center">
    <h1 style="font-size: 18px" class="m-0 mb-4">{{ 'ZenBoss::Banners.Manage' | abpLocalization }}</h1>
  </div>
  <lib-banner-upload [isList]="true"></lib-banner-upload>
  <lib-banner-upload [isList]="false"></lib-banner-upload>
</div>
